import { render, staticRenderFns } from "./TransferOwnershipComponent.vue?vue&type=template&id=31e44554&"
import script from "./TransferOwnershipComponent.vue?vue&type=script&lang=ts&"
export * from "./TransferOwnershipComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports